<script>
import { LicenseComputed } from '@state/modules/license'
import _baseDropdownPicker from '../_base-dropdown-picker.vue'
export default {
  name: 'LicensePicker',
  extends: _baseDropdownPicker,
  model: {
    event: 'change',
  },
  props: {
    mandatory: { type: Boolean, default: false },
  },
  computed: {
    ...LicenseComputed,
    options() {
      return [
        { text: this.$t('named_user'), key: 'named_user' },
        { text: this.$t('concurrent_user'), key: 'concurrent_user' },
      ]
    },
    disabled() {
      return (
        this.userLicenseType === 'concurrent' ||
        this.userLicenseType === 'named'
      )
    },
  },
}
</script>
